import { render, staticRenderFns } from "./dj-form.vue?vue&type=template&id=2b919809&scoped=true&"
import script from "./dj-form.vue?vue&type=script&lang=js&"
export * from "./dj-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b919809",
  null
  
)

export default component.exports